import Axios from 'api/client';
import { SmsKeyword } from 'types/domain';
import { PaginatedData } from 'types/pagination';

interface FetchShortCodeParams {
    page: number;
}

interface AddShortCodeParams {
    modelId: string;
    keyword: string;
}

interface UpdateShortCodeParams {
    modelId: string;
    keyword: string;
}

interface DeleteShortCodeParams {
    keywordId: number;
}

export const fetchShortCodes = (accountId: number, params: FetchShortCodeParams) =>
    Axios.get<PaginatedData<SmsKeyword>>(`/accounts/${accountId}/sms_keywords?type=campaigns`, {
        params,
    }).then(response => response.data);

export const fetchShortCode = (accountId: number, keywordId: number) =>
    Axios.get<SmsKeyword>(`/accounts/${accountId}/sms_keywords/${keywordId}`).then(
        response => response.data,
    );

export const addShortCode = (accountId: number, { keyword, modelId }: AddShortCodeParams) =>
    Axios.post(`/accounts/${accountId}/sms_keywords`, {
        keyword,
        model_id: modelId,
        model: { id: modelId, table: 'campaigns' },
    }).then(response => response.data);

export const updateShortCode = (
    accountId: number,
    keywordId: number,
    { keyword, modelId }: UpdateShortCodeParams,
) =>
    Axios.patch(`/accounts/${accountId}/sms_keywords/${keywordId}`, {
        keyword,
        model_id: modelId,
        model: { id: modelId, table: 'campaigns' },
    }).then(response => response.data);

export const deleteShortCode = (accountId: number, { keywordId }: DeleteShortCodeParams) =>
    Axios.delete(`/accounts/${accountId}/sms_keywords/${keywordId}`).then(
        response => response.data,
    );
